export default __webpack_public_path__ + "static/media/samplecash.dd4536da.xlsx";